import React, { createContext, useState, useEffect } from "react";
import { API_BASE_URL } from "../Config";

export const MaintenanceModeContext = createContext();

// Função para obter o token CSRF
function getCsrfToken() {
  const csrfToken = document.cookie.split(';')
    .map(cookie => cookie.trim())
    .find(cookie => cookie.startsWith('csrftoken='))
    ?.split('=')[1];
  return csrfToken;
}

export const MaintenanceModeProvider = ({ children }) => {
  const [maintenanceMode, setMaintenanceMode] = useState(null);

  useEffect(() => {
    async function fetchMaintenanceMode() {
      const csrfToken = getCsrfToken();
      const response = await fetch(`${API_BASE_URL}/api/maintenance_mode/`, {
        method: 'GET',
        credentials: 'include',  // Inclua as credenciais de sessão
        headers: {
          'X-CSRFToken': csrfToken  // Inclua o token CSRF
        }
      });

      if (response.ok) {
        const data = await response.json();
        setMaintenanceMode(data.maintenance_mode === "True");
      } else {
        console.error("Failed to fetch maintenance mode data", response.status, response.statusText);
      }
    }

    fetchMaintenanceMode();
  }, []);

  return (
    <MaintenanceModeContext.Provider value={maintenanceMode}>
      {children}
    </MaintenanceModeContext.Provider>
  );
};
